<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()"><ion-icon slot="start" name="close"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title clas="ion-text-center">Account löschen</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">

  <ion-grid fixed>
    <ion-row class="ion-justify-content-center">
      <ion-col size="12">
        <ion-item color="danger" class="ion-padding">
          <ion-text  class="ion-text-center">
            <b>Warnung</b>
            Laden Sie bitte alle Ihre Dokumente herrunter bevor Sie den Account löschen! Wir können diese nach
            dem Löschen nicht wiederherstellen.
          </ion-text>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="ion-padding">
    <form id="accountForm" [formGroup]="accountDeleteForm" (ngSubmit)="onAccountDelete()" novalidate>
      <ion-list>
        <ion-item>
          <ion-label position="stacked">
            Aktuelles Passwort
          </ion-label>
          <ion-input type="password" autofocus="true" autcomplete="password" inputmode="password" name="current_password" formControlName="current_password"></ion-input>
        </ion-item>
      </ion-list>
      <ion-button color="danger" type="submit" size="block" [disabled]="!accountDeleteForm.dirty || accountDeleteForm.invalid">Account löschen</ion-button>
    </form>
  </div>
</ion-content>
